module.exports = __webpack_public_path__ + "img/logo.a2f66ed5.png";